import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import BackButton from '@assets/img/icons/back-button.svg?react';

import { type Reward } from '@/common/types/earnRewardsType';
import { H2 } from '@/components/Typography/Typography';

import RewardsList from '../RewardsList/RewardsList';

interface PlanCalendarProps {
  rewards?: Reward[];
  prevTab: () => void;
}

const PlanCalendar: FC<PlanCalendarProps> = ({ prevTab, rewards }) => {
  const { t } = useTranslation();

  const activeReward = rewards?.[0];

  return (
    <>
      <div className="grid grid-cols-[3rem,1fr,3rem] place-items-center w-full pt-4 px-4">
        <button onClick={prevTab}>
          <BackButton className="size-full" />
        </button>
        <H2 weight="black" className="text-center">
          {t('Full Calendar')}
        </H2>
      </div>
      <div className="self-stretch mt-5 overflow-auto">
        <RewardsList activeReward={activeReward} rewards={rewards} />
      </div>
    </>
  );
};

export default PlanCalendar;
